<template>
  <div id="app">
    <!-- Navbar Section -->
    <NavBar />

  
    <router-view></router-view> 
    
    <!-- Footer Section -->
    <FooterPage />

  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
// import HomePage from "@/components/HomePage.vue";
import FooterPage from "@/components/FooterPage.vue"; 
import "@/assets/css/style.css"; 

export default {
  name: "App",
  components: {
    NavBar,
    // HomePage,
    FooterPage,
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: Arial, sans-serif;
}
</style>
